/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScoringParameters } from '../../models/scoring-parameters';
import { ScoringParametersDto } from '../../models/scoring-parameters-dto';

export interface AddScoringParameters$Params {
      body: ScoringParametersDto
}

export function addScoringParameters(http: HttpClient, rootUrl: string, params: AddScoringParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<ScoringParameters>> {
  const rb = new RequestBuilder(rootUrl, addScoringParameters.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScoringParameters>;
    })
  );
}

addScoringParameters.PATH = '/api/scoringparameters';
